import { useMapPanelContext } from '../../modules/Map/MapPanel';
import { CENTERCOMPONENTS } from '../../modules/Map/MapPanel';
import { ACTIVETAB, RIGHTSIDECOMPONENTS } from '../../modules/Map/MapPanel';
import { useReportContext } from '../../modules/Reports/ReportContext';
import { useViewMode, ViewMode } from '../ViewModeProvider';

export const shapesButtonId = 'shapes-sidebar-menu-button';
export const filtersButtonId = 'filters-sidebar-menu-button';
export const reportsButtonId = 'reports-sidebar-menu-button';
export const eventsButtonId = 'events-sidebar-menu-button';
export const replayButtonId = 'replay-sidebar-menu-button';
export const atonsButtonId = 'atons-sidebar-menu-button';
export const portAdminButtonId = 'portadmin-sidebar-menu-button';

export const messagesButtonId = 'messages-sidebar-menu-button';

export const useSidebarItemAction = () => {
  const {
    activeTab,
    navigateToTab,
    setRightSideComponent,
    centerComponent,
    setCenterComponent,
    setCenterComponentData,
    setTabChange,
    setTableExpanded,
  } = useMapPanelContext();
  const { viewMode, setViewMode } = useViewMode();

  const { resetReportContext } = useReportContext();

  return (id: string) => {
    if (
      centerComponent === CENTERCOMPONENTS.SHIPTABLE ||
      centerComponent === CENTERCOMPONENTS.ROUTES
    ) {
      setCenterComponent(CENTERCOMPONENTS.NONE);
    }

    setCenterComponentData(null);
    setTabChange(true);
    resetReportContext();
    setTableExpanded(true);

    // We do not want to reset it to normal if the viewmode is replay
    if (viewMode === ViewMode.Detail) {
      setViewMode(ViewMode.Normal);
    }

    switch (id) {
      case shapesButtonId:
        if (activeTab === ACTIVETAB.SHAPES) {
          navigateToTab(ACTIVETAB.NONE);
          setRightSideComponent(RIGHTSIDECOMPONENTS.NONE);
        } else {
          navigateToTab(ACTIVETAB.SHAPES);
          setRightSideComponent(RIGHTSIDECOMPONENTS.SHAPES);
        }
        break;
      case filtersButtonId:
        if (activeTab === ACTIVETAB.FILTERS) {
          setRightSideComponent(RIGHTSIDECOMPONENTS.NONE);
          navigateToTab(ACTIVETAB.NONE);
        } else {
          setRightSideComponent(RIGHTSIDECOMPONENTS.FILTERS);
          navigateToTab(ACTIVETAB.FILTERS);
        }
        break;
      case reportsButtonId:
        if (activeTab === ACTIVETAB.REPORTS) {
          setRightSideComponent(RIGHTSIDECOMPONENTS.NONE);
          navigateToTab(ACTIVETAB.NONE);
        } else {
          setRightSideComponent(RIGHTSIDECOMPONENTS.REPORTS);
          navigateToTab(ACTIVETAB.REPORTS);
        }
        break;
      case eventsButtonId:
        if (activeTab === ACTIVETAB.EVENTS) {
          setRightSideComponent(RIGHTSIDECOMPONENTS.NONE);
          navigateToTab(ACTIVETAB.NONE);
        } else {
          setRightSideComponent(RIGHTSIDECOMPONENTS.EVENTS);
          navigateToTab(ACTIVETAB.EVENTS);
        }
        break;
      case replayButtonId:
        if (activeTab === ACTIVETAB.REPLAY) {
          setRightSideComponent(RIGHTSIDECOMPONENTS.NONE);
          navigateToTab(ACTIVETAB.NONE);
        } else {
          setRightSideComponent(RIGHTSIDECOMPONENTS.NONE);
          navigateToTab(ACTIVETAB.REPLAY);
        }
        break;
      case atonsButtonId:
        if (activeTab === ACTIVETAB.ATONS) {
          setRightSideComponent(RIGHTSIDECOMPONENTS.NONE);
          navigateToTab(ACTIVETAB.NONE);
        } else {
          setRightSideComponent(RIGHTSIDECOMPONENTS.NONE);
          navigateToTab(ACTIVETAB.ATONS);
        }
        break;
      case messagesButtonId:
        if (activeTab === ACTIVETAB.MESSAGES) {
          setRightSideComponent(RIGHTSIDECOMPONENTS.NONE);
          navigateToTab(ACTIVETAB.NONE);
        } else {
          setRightSideComponent(RIGHTSIDECOMPONENTS.NONE);
          navigateToTab(ACTIVETAB.MESSAGES);
        }
        break;
      case portAdminButtonId:
        if (activeTab === ACTIVETAB.PORTADMIN) {
          setRightSideComponent(RIGHTSIDECOMPONENTS.NONE);
          navigateToTab(ACTIVETAB.NONE);
        } else {
          setRightSideComponent(RIGHTSIDECOMPONENTS.PORTADMIN);
          navigateToTab(ACTIVETAB.PORTADMIN);
        }
        break;
      default:
        setRightSideComponent(RIGHTSIDECOMPONENTS.NONE);
        navigateToTab(ACTIVETAB.NONE);
        break;
    }
  };
};
